import React from 'react';
import cn from 'classnames';
import FlatCell from '../FlatCell/FlatCell';
import { getNumberUpToPoint } from '../../utils';
import { gridContainerTypes } from '../../constants';
import {
  acceptanceStatusesColorsMap,
  addressStagesColorsMap,
} from '../../../../../constants/stagesColorMaps';
import { flatTypesColorsMap } from '../../../../../constants/typesColorMaps';
import styles from './GridContainer.module.scss';
import { useSelector } from 'react-redux';
import { chessViewMode } from '../../../../../constants/chessViewMode';
import useColorChess from '../../../../../hooks/useColorChess';
import useBorderColorStagesFlat from '../../../../../hooks/useBorderColorStagesFlat';

const rowPosition = (cells, gridType) => {
  const start = getNumberUpToPoint(cells[0].row);
  const end = getNumberUpToPoint(cells[cells.length - 1].row);

  if (gridType === gridContainerTypes.upper) {
    return `-${start + 1}/-${end + 2}`;
  }

  if (gridType === gridContainerTypes.basement) {
    return `${start + 1}/${end + 2}`;
  }

  if (gridType === gridContainerTypes.under) {
    return `${Math.abs(start)}/${Math.abs(end) + 1}`;
  }
};

const GridContainer = ({
  onMouseOver,
  onMouseOut,
  rowSize,
  numOfCol,
  colSize,
  flats,
  type = gridContainerTypes.upper,
  onFlatClick,
  isPreview,
  title,
}) => {
  const chessViewColorMode = useSelector(
    (state) => state.housingStockStore.chessViewColorMode
  );

  const getColorForFlat = useColorChess();
  const getBorderColorStagesFlat = useBorderColorStagesFlat();

  const getBgColor = (item) => {
    if (chessViewColorMode === chessViewMode.applicationMonitoring) {
      return getColorForFlat(item);
    } else if (chessViewColorMode === chessViewMode.stages) {
      const stageId = item.addressLifeCycle?.stageAddressLifeCycle?.id;
      return stageId ? addressStagesColorsMap.get(stageId) : undefined;
    } else {
      const acceptanceId =
        item.addressLifeCycle?.acceptanceStatusAddressLifeCycle?.id;
      return acceptanceId
        ? acceptanceStatusesColorsMap.get(acceptanceId)
        : undefined;
    }
  };

  return (
    <div
      className={cn(styles.root)}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      style={{
        marginTop: type !== gridContainerTypes.upper ? '8px' : 0,
        gridAutoRows: `${rowSize}`,
        gridTemplateColumns: `repeat(${numOfCol}, minmax(${colSize}, 1fr))`,
      }}
    >
      {flats.map((flat) => {
        const cells = Array.isArray(flat) ? flat[0].cells : flat.cells;
        const row = rowPosition(
          cells.slice().sort((a, b) => a.row - b.row),
          type
        );
        const colCells = cells.slice().sort((a, b) => a.col - b.col);
        const colStart = getNumberUpToPoint(colCells[0].col);
        const colEnd =
          getNumberUpToPoint(colCells[colCells.length - 1].col) + 1;

        return (
          <div
            key={flat.flat}
            style={{
              gridRow: row,
              gridColumn: `${colStart}/${colEnd}`,
            }}
            className={styles.cell}
          >
            {Array.isArray(flat) &&
              flat.map((item) => (
                <FlatCell
                  key={item.flat}
                  flatData={item}
                  onClick={onFlatClick}
                  isPreview={isPreview}
                  bgColor={getBgColor(item)}
                  borderColor={
                    chessViewColorMode === chessViewMode.applicationMonitoring
                      ? getBorderColorStagesFlat(item)
                      : item.address
                      ? flatTypesColorsMap.get(item.address.typeId)
                      : undefined
                  }
                />
              ))}
            {!Array.isArray(flat) && (
              <FlatCell
                isPreview={isPreview}
                flatData={flat}
                onClick={onFlatClick}
                bgColor={getBgColor(flat)}
                borderColor={
                  chessViewColorMode === chessViewMode.applicationMonitoring
                    ? getBorderColorStagesFlat(flat)
                    : flat.address
                    ? flatTypesColorsMap.get(flat.address.typeId)
                    : undefined
                }
              />
            )}
          </div>
        );
      })}
      {title && (
        <h4 className={cn(styles.title, styles.allColumns)}>
          <span>{title}</span>
        </h4>
      )}
    </div>
  );
};

export default GridContainer;
